// extracted by mini-css-extract-plugin
export default {"school-of-disco-banner":"ISH63B5cllYp50MZlGls","school-of-disco-banner-link":"D6RjFnjb5F47vmG8NcNz","school-of-disco-banner--text-guidance":"hsQAxNylWQcGSQb8rKCX"};